import Component from '../../../../types/common/Component';
import ErrorType from '../../../../types/report/ErrorType';
import UserDefinedFunction from '../../../../types/report/UserDefinedFunction';
import UserDefinedFunctionParameter from '../../../../types/report/UserDefinedFunctionParameter';
import { reportType } from '../../../constants/reportType';
import clear from '../../common/array/clear';
import httpClient from '../../common/httpClient';
import stringHelper from '../../common/stringHelper';
import urlHelper from '../../common/urlHelper';
import declarationValidator from './declarationValidator';
import uniquenessValidator from './uniquenessValidator';

const maxNameCharacters = 50;

const validateFunctionParameter = (parameter: UserDefinedFunctionParameter): void => {

    clear(parameter.errors);

    if (stringHelper.isEmpty(parameter.name)) {
        parameter.errors.push('Parameter name is required');
    }

    if (parameter.name.length > maxNameCharacters) {
        parameter.errors.push(`Parameter name max character count is ${maxNameCharacters}`);
    }
};

const validateFunction = async (func: UserDefinedFunction, functions: UserDefinedFunction[], globalFunctions: UserDefinedFunction[], reportConfigType: string): Promise<void> => {

    clear(func.errors);

    let metadataError = await validateMetadata(func.name, reportConfigType === reportType.globalModule);
    if (metadataError) {
        func.errors.push(metadataError);
    }

    declarationValidator.validate(func, functions, globalFunctions, [], [], [], [], [], null as any, func.returnType, null, true, reportConfigType);
};

const validateFunctions = async (functions: UserDefinedFunction[], globalFunctions: UserDefinedFunction[], reportConfigType: string): Promise<ErrorType> => {

    for (let index = 0; index < functions.length; index++) {
        const func = functions[index];

        await validateFunction(func, functions, globalFunctions, reportConfigType);
    }

    uniquenessValidator.validate(functions, a => a.name, 'User Defined Function', 'name');

    let invalidFunction = functions.find(x => x.errors.length > 0);

    return {
        mainConmponentNumber: invalidFunction?.number as number,
        message: invalidFunction ? 'Invalid functions(s)' : ''
    } as ErrorType;
};

const validateFunctionParameters = (funcs: UserDefinedFunction[]): ErrorType => {

    funcs.forEach((func) => {
        func.parameters.forEach(x => validateFunctionParameter(x));

    });

    let functionWithErrorParameters = funcs.find(x => x.parameters.some(f => f.errors.length > 0));

    let fieldWithErrors = functionWithErrorParameters?.parameters?.find(x => x.errors.length > 0);

    return {
        message: fieldWithErrors ? 'Invalid functions(s)' : '',
        componentNumber: fieldWithErrors?.number,
        mainConmponentNumber: functionWithErrorParameters?.number as number
    }
}

const validateMetadata = async (name: string, isGlobalConfig: boolean): Promise<string | null> => {

    if (stringHelper.isEmpty(name)) {
        return 'Function name is required';
    }

    if (name.length > maxNameCharacters) {
        return `Function name max character count is ${maxNameCharacters}`;
    }

    let functionComponentsInDb = await getFunctionNames(isGlobalConfig);

    let error = '';

    functionComponentsInDb.filter(x=>x.name===name).forEach((component) => {
        error += `Function name "${component.name}" already exits in config "${component.reportConfigName}" with Id: ${component.reportConfigId}. Please change it.")`;
    });

    return error || null;
};

const getFunctionNames = async (isGlobalConfig: boolean): Promise<Component[]> => {

    let res = await httpClient.getWithAsyncAwait(`report/functions/names/${isGlobalConfig}`);

    return res.data;
}

const functionValidator = {
    validateFunctions,
    validateFunction,
    validateFunctionParameter,
    validateFunctionParameters,
    validateMetadata
};

export default functionValidator;
